import appModuleRegistry from "components/appModules/appModuleRegistry";
import { LocalStorage } from "components/appModules/LocalStorage";
import { ComponentDefinition } from "components/components/Component";
import { MenuElement } from "components/menu/menuElement";
import { Renderer } from "components/Renderer";
import { S6Request } from "components/request/request";
import sislogUserGlobals from "components/UserGlobals";
import $ from "jquery";
import contextBlockTemplate from "./contextBlock.hbs";

export class IndexHeader {
    public static readonly instance: IndexHeader = new IndexHeader();

    private menus = {};
    private view: Element;
    private contextHost: Element;
    private contextDescriptionCache: any = {};
    private desiredMenuRef: string;
    private currentMenuRef: string;
    private sideMenuHost;

    public init(view: Element) {
        this.view = view;
        this.contextHost = this.view.getElementsByClassName("c-main-page__app-context")[0];
        this.drawEnviromentLabel();
    }

    public updateHeader(sideMenuHost = null): void {
        if (sideMenuHost != null) {
            this.sideMenuHost = sideMenuHost;
        }
        let menuHost = this.view.getElementsByClassName("c-main-page__menu-container")[0];
        this.updateContext();
        this.drawMenu(menuHost, this.sideMenuHost);
    }

    private updateContext() {

        let appPrefix = "";
        if (appModuleRegistry.currentApp != null) {
            appPrefix = appModuleRegistry.currentApp.prefix + ":/";
        }
        for (let c in sislogUserGlobals.appEnvironment) {
            if (sislogUserGlobals.appEnvironment.hasOwnProperty(c)) {

                if (this.contextDescriptionCache[c] == null) {
                    this.contextDescriptionCache[c] = {};
                }
                let contextKey = sislogUserGlobals.appEnvironment[c];
                if (this.contextDescriptionCache[c][contextKey] == null) {

                    let url = appModuleRegistry.prefixUrl(
                        appPrefix + "context-detail/" + c + "/" + contextKey + ".json");
                    S6Request.url(url).get()
                        .res((json: { detail: any; }) => {
                            this.contextDescriptionCache[c][contextKey] = json.detail;
                            this.drawContextInFinished();
                        })
                        .catch((ex: any) => {
                            console.error("error loading context description", ex);
                        });
                }
            }
        }
        this.drawContextInFinished();
    }

    private drawContextInFinished() {
        let contextHtml = "";
        let appPrefix = "";
        let completed = 0;
        let total = 0;
        if (appModuleRegistry.currentApp != null) {
            appPrefix = appModuleRegistry.currentApp.prefix;
        }
        for (let c in sislogUserGlobals.appEnvironment) {
            if (sislogUserGlobals.appEnvironment.hasOwnProperty(c)) {
                total++;
                let contextKey = sislogUserGlobals.appEnvironment[c];
                if (this.contextDescriptionCache[c] != null
                    && this.contextDescriptionCache[c][contextKey] != null) {
                    let contextBlockParams: any = {};
                    contextBlockParams.key = appPrefix + ":global_context." + c + ".key";
                    contextBlockParams.contextKey = sislogUserGlobals.appEnvironment[c];
                    contextBlockParams.contextDetail = this.contextDescriptionCache[c][contextKey];
                    contextHtml += contextBlockTemplate(contextBlockParams);
                    completed++;
                }
            }
        }

        if (completed === total
            && this.contextHost.innerHTML !== contextHtml) {
            this.contextHost.innerHTML = contextHtml;
        }
    }

    private drawMenu(host: Element, sideMenuHost) {
        if (this.currentMenuRef !== this.desiredMenuRef) {
            let desiredMenu = this.menus[this.desiredMenuRef];
            if (desiredMenu == null) {
                return;
            }
            this.currentMenuRef = this.desiredMenuRef;
            Renderer.instance().fullComponentRender(
                { ...desiredMenu.definition, componentType: "menu" },
                sideMenuHost);
        }
    }

    private drawEnviromentLabel() {
        let url = appModuleRegistry.apps[0].baseUrl;
        fetch(url + "/admin/envSislog")
            .then((response) => {
                if (response.ok) {
                    return response.text();
                } else {
                    return "";
                }
            })
            .then((data) => {
                this.view.querySelector(".c-main-page__env").innerHTML = data;
            });
    }

    public reset(): void {
        this.menus = {};
        this.desiredMenuRef = undefined;
        this.currentMenuRef = undefined;
    }

    public updateHeaderForApp(appPrefix: string) {

        this.loadMenu(appPrefix);
        if (this.view != null) {
            this.updateHeader();
        }
    }

    private loadMenu(appPrefix: string) {
        const menuRef = appPrefix + sislogUserGlobals.dash();
        this.desiredMenuRef = menuRef;
        if (this.menus[menuRef] == null) {
            let url: string;
            if (appPrefix === "main") {
                url = "pages/index/menu.json";
            } else if (appPrefix === "dashboard") {
                url = "pages/dashboard/menu.json";
            } else {
                let uid = LocalStorage.getUid();
                url = appModuleRegistry.prefixUrl(appPrefix + ":/menu/" + uid + ".json");
            }
            url = sislogUserGlobals.appendUrlParams(url);
            S6Request.url(url).get()
                .res((json: ComponentDefinition) => {
                    this.menus[menuRef] = Renderer.instance().build(json);
                    if ($(".c-main-page__sidebar-menu").length > 0) {
                        this.updateHeader();
                    }
                })
                .catch((ex: any) => {
                    console.error("error loading menu", ex);
                });
        }
    }
}
